import { Controller } from "@hotwired/stimulus";

const YOUTUBE_REGEX =
  /^https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
const VIMEO_REGEX =
  /^https?:\/\/(?:www\.)?(?:vimeo\.com|player\.vimeo\.com\/video)\/(\d+)/;

export default class extends Controller {
  static targets = ["urlInput", "previewArea", "previewFrame"];

  urlChanged() {
    const url = this.urlInputTarget.value.trim();
    const embedUrl = this.#toEmbedUrl(url);

    if (embedUrl) {
      this.previewFrameTarget.src = embedUrl;
      this.previewAreaTarget.classList.remove("hidden");
    } else {
      this.previewFrameTarget.removeAttribute("src");
      this.previewAreaTarget.classList.add("hidden");
    }
  }

  #toEmbedUrl(url) {
    let match;

    match = url.match(YOUTUBE_REGEX);
    if (match) return `https://www.youtube.com/embed/${match[1]}`;

    match = url.match(VIMEO_REGEX);
    if (match) return `https://player.vimeo.com/video/${match[1]}`;

    return null;
  }
}
